import { Type } from "@sinclair/typebox";
/* 浏览器与服务端共用的传输 schema，不加载服务端策略摘要及 Node 能力。 */
export const ModelTransportPolicySchema = Type.Object({
    memoryBytes: Type.Integer({ minimum: 1, maximum: Number.MAX_SAFE_INTEGER }),
    concurrency: Type.Integer({ minimum: 1, maximum: 1024 }),
    maximumRequestBytes: Type.Integer({ minimum: 1, maximum: Number.MAX_SAFE_INTEGER }),
}, { additionalProperties: false });
//# sourceMappingURL=model-transport.js.map